// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__CaZoq","loader1":"Loader_loader1__xYEV4","loader2":"Loader_loader2__40s4Y","loader3":"Loader_loader3__Z+bGt"};